import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { NgClass } from "@angular/common";

@Component({
  selector: 'app-password-strength',
  templateUrl: './password-strength.component.html',
  styleUrls: ['./password-strength.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgClass
  ]
})
export class PasswordStrengthComponent {
  @Input() control!: AbstractControl;

  get strengthLevel(): 'weak' | 'moderate' | 'strong' | '' {
    if (!this.control || !this.control.value) return '';

    const password = this.control.value;
    const validCriteriaCount = this.getValidCriteriaCount(password);

    if (validCriteriaCount === 5) return 'strong';
    if (validCriteriaCount >= 3) return 'moderate';
    if (validCriteriaCount >= 1) return 'weak';
    return '';
  }

  get strength(): string {
    switch (this.strengthLevel) {
      case 'strong': return $localize`Strong`;
      case 'moderate': return $localize`Moderate`;
      case 'weak': return $localize`Weak`;
      default: return '';
    }
  }

  get criteria() {
    const password = this.control?.value || '';
    return {
      hasMinLength: password.length >= 12,
      hasLowercase: /[a-z]/.test(password),
      hasUppercase: /[A-Z]/.test(password),
      hasNumber: /\d/.test(password),
      hasSpecialChar: /[\W_]/.test(password),
    };
  }

  private getValidCriteriaCount(password: string): number {
    const criteria = {
      hasMinLength: password.length >= 12,
      hasLowercase: /[a-z]/.test(password),
      hasUppercase: /[A-Z]/.test(password),
      hasNumber: /\d/.test(password),
      hasSpecialChar: /[\W_]/.test(password),
    };
    return Object.values(criteria).filter(Boolean).length;
  }
}
